<template>
  <div>
    <section-header :ressource="ressource"
                    :isExtended="true"
                    :dialog="true"
                    @closeDialog=closeDialog
                    ref="WIZARD">
    </section-header>
    <div class='py-2'>
      <edit-field :value="wizardItem.label"
                  :editFieldInfo="labelFieldInfo"
                  @updated="setLabel">
      </edit-field>

      <html-field :label="ressourceTitle"
                  :value="wizardItem.title"
                  :params="htmlParams"
                  @updated="setTitle">
      </html-field>

      <html-field :label="ressourceDescription"
                  :value="wizardItem.description"
                  :params="htmlParams"
                  @updated="setDescription">
      </html-field>

      <v-file-input v-model="file"
                    accept="image/*"
                    :label="uploadImageLabel"
                    @change="createImage">
      </v-file-input>
      <v-img :src='wizardItem.picto'></v-img>
    </div>
    <div class="d-flex flex-row-reverse">
      <loader-button class="ms-2"
                      type='button'
                      :label="saveLabel"
                      :disabled="!updated"
                      @callback="save">
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { FwkButtons, FwkControls, FwkSections, RessourceFwkButton, RessourceFwkControl, RessourceFwkSection } from '@/ressources/globalRessources';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import EditField from '@/framework/base/components/EditField.vue';
import { FieldInfo, EditFieldType, EditFieldTheme } from '@/framework/base/components/FieldInfo';
import SectionContainer from '@/framework/base/components/SectionContainer.vue';
import HtmlAttrib, { HtmlParam } from '@/generated/classes/HtmlAttrib';
import HtmlField from '@/framework/base/components/HtmlField.vue';
import WizardItem from '@/generated/classes/WizardItem';
import { storeWizardItem } from '@/generated/stores';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  name: 'SectionAdminWizardItem',
  components: {
    LoaderButton,
    SectionHeader,
    EditField,
    SectionContainer,
    HtmlField
  },
  props: {
    wizardItem: {
      type: Object as PropType<WizardItem>,
      required: false,
    },
  },
  data() {
    return {
      refWizardItem: new WizardItem(),
      file: null as File | null,
      htmlAttrib: new HtmlAttrib(),
      updated: false,
    };
  },
  computed: {
    saveLabel(): any { return RessourceFwkButton(FwkButtons.ENREGISTRER).label; },
    ressource(): any { return RessourceFwkSection(FwkSections.WIZARD); },
    ressourceDescription(): any { return RessourceFwkSection(FwkSections.WIZARD_ITEM).label; },
    uploadImageLabel(): any { return RessourceFwkControl(FwkControls.UPLOAD_IMAGE).label; },
    ressourceTitle(): any { return RessourceFwkControl(FwkControls.TITLE).label; },
    ressourceLabel(): any { return RessourceFwkControl(FwkControls.LABEL).label; },
    labelFieldInfo(): FieldInfo {
      const ressource = RessourceFwkControl(FwkControls.LABEL);
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
    },
    htmlValue(): string {
      return this.htmlAttrib.html;
    },
    htmlParams(): HtmlParam[] {
      return this.htmlAttrib.publiParams;
    },
  },
  created(): void {
    this.refWizardItem = WizardItem.fromJson(this.wizardItem);
    if (this.wizardItem.title == null) {
      this.wizardItem.title = "";
      HtmlAttrib.get(this.wizardItem.titleHtmlId).then((res) => {
        this.htmlAttrib = res;
        if (res.html != null) {
          this.wizardItem.title = res.html;
        } else {
          this.wizardItem.title = "";
        }
      });
    }
    if (this.wizardItem.description == null) {
      this.wizardItem.description = "";
      HtmlAttrib.get(this.wizardItem.descriptionHtmlId).then((res) => {
        this.htmlAttrib = res;
        if (res.html != null) {
          this.wizardItem.description = res.html;
        } else {
          this.wizardItem.description = "";
        }
      });
    }
    HtmlAttrib.listParam("Users").then((res) => {
      this.htmlAttrib.publiParams = res;
    });
  },
  beforeUnmount() {
    const items = storeWizardItem.listWizardItem;
    items.forEach((item) => {
      if (item.id < 0) {
        storeWizardItem.mWizardItemDeleted(item.id);
      }
    })
  },
  methods: {
    setTitle(value: string) {
      this.wizardItem.title = value;
      this.setUpdated();
    },
    setDescription(value: string) {
      this.wizardItem.description = value;
      this.setUpdated();
    },
    setLabel(value: string) {
      this.wizardItem.label = value;
      this.setUpdated();
    },
    createImage(file: File) {
      const reader = new FileReader();
      reader.onload = (event) => {
        // @ts-expect-error : generated method
        this.wizardItem.picto = event.target.result;
      }
      reader.readAsDataURL(file);
      this.setUpdated();
    },
    save(): void {
      if (this.wizardItem.id > 0) {
        storeWizardItem.updateWizardItem(this.wizardItem).then((res) => {
          this.$emit('updated', res);
          this.closeDialog();
        });
      } else {
        storeWizardItem.createWizardItem(this.wizardItem).then((res) => {
          this.$emit('updated', res);
          this.closeDialog();
        });
      }
    },
    setUpdated() {
      const ref = JSON.stringify(this.refWizardItem);
      const wizard = JSON.stringify(this.wizardItem);
      this.updated = (ref != wizard);
    },
    closeDialog(): void {
      this.$emit('closeDialog');
    },
  },
});
</script>